import {subdomainLink} from '../../../helpers/url'
import React from 'react'
import {Consumer} from '../../../context'
import {faBook} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import Icon from '../../icon'
import {viewerGuard} from 'helpers/url'

export default function UploadLinks (props) {
  const {name, id} = props
  return (<Consumer>{ context => {
    const {groupsDigests, languageId} = context
    const digest = groupsDigests[id]
    return (
      <div className="links">
        {digest && (
          <div className="rollbook">
            <a
              {...viewerGuard({href: subdomainLink('assessment',languageId, `roll_book#${digest}`), target: "_blank"})}
            >
              <FontAwesomeIcon icon={faBook} />
            </a>
          </div>
        )}
        {digest && (
          <div className="publish">
            <a
              {...viewerGuard({href: subdomainLink('assessment',languageId, `publishing_roll_book#${digest}`), target: "_blank"})}
            >
              <Icon name="rollbook-link" />
            </a>
          </div>
        )}
      </div>
    )
  }}</Consumer>)
}
